import api from "@/services/api";
import store from "@/store/index";
import { debugError, debugLog } from "@/plugins/debug";
export default {
    // LOOKUPS
    async get_genders() {
        let gender_lookups = [];
        await api.lookups.getGenders()
            .then(res => {
                debugLog('====Get genders Response========', res);
                gender_lookups = res.data.Lookups;
            }).catch(err => {
                debugError(`${err}`);
            });
        return gender_lookups
    },

    async get_relations(DocCode,genderCode) {

        let relation_lookups = [];
        await api.lookups.getRelationsByDocument({ DocCode: DocCode, genderCode: genderCode })
            .then(res => {
                debugLog('====Get relations Response========', res);
                relation_lookups = res.data.Lookups;
            }).catch(err => {
                debugError(`${err}`);
            });
        return relation_lookups
    },

    async get_servicePrice(docType, DocumentTypeCode = "MOICSO112") {

        let price = 0;
        if (docType === "nidFormPrice") {
            await api.servicePrice[docType](DocumentTypeCode)
                .then(res => {
                    debugLog('====Get get_servicePrice Response========', res); 
                    price = res.data;
                }).catch(err => {
                    debugError(`${err}`); 
                });
        } else {
            await api.servicePrice[docType]()
                .then(res => {
                    debugLog('====Get get_servicePrice Response========', res); 
                    price = res.data;
                }).catch(err => {
                    debugError(`${err}`); 
                });
        }

        return price
    },

    async get_govCodes() {

        let GovCode_lookups = [];
        await api.lookups.GovCodes()
            .then(res => {
                debugLog('====Get Gov Codes Response========', res);
                GovCode_lookups = res.data.Lookups;
            }).catch(err => {
                debugError(`${err}`); 
            });
        return GovCode_lookups
    },

    async get_postalCodes(govCode) {
        let postalCode_lookups = [];
        await api.lookups.PostalCodesByGov(govCode)
            .then(res => {
                debugLog('====Get Postal Codes Response========', res);
                postalCode_lookups = res.data.Lookups;
            }).catch(err => {
                debugError(`${err}`); 
            });
        return postalCode_lookups
    },

    async get_policeCodes(govCode) {
        let policeCode_lookups = [];
        await api.lookups.PoliceCodesByGov(govCode)
            .then(res => {
                debugLog('====Get Police Codes Response========', res);
                policeCode_lookups = res.data.Lookups;
            }).catch(err => {
                debugError(`${err}`); 
            });
        return policeCode_lookups
    },

    async getRegulations(docCode){
        debugLog('DOCUMENT CODE',docCode);
        let regulation_lookups = [];
        const headers= { 
                         'DocumentTypeCode':docCode,
                         'JobTypeNIDCode': 'NONE',
                         'correlationId':1,
                         'originatingChannel':1,
                         'channelRequestId':1,
                         'originatingUserType':1,
                         'originatingUserIdentifier':1,
                         'serviceEntityId': 1,
                         'serviceSlug':1,
                         'responseCode':1,     
                 }
         await api.lookups.getRegulations(headers)   
        .then(res => {      
            debugLog('====Get Regulations Response========',res); 
         regulation_lookups = res.data.Regulations;       
         }).catch(err => {
            debugError(`${err}`); 
         });
        
         return regulation_lookups  
     },

    async get_nidIssueReasons(){
        let nidIssues_lookups = [];

        await api.lookups.nidIssueReasons()   
       .then(res => {      
        debugLog('====GET NID ISSUES RESPONSE========',res); 
        nidIssues_lookups = res.data.Lookups;       
        }).catch(err => {
            debugError(`${err}`);      
        });

        return nidIssues_lookups
    },
    
    // PREVIEW MODE DOC REQUEST
    async PreviewDoc(data,options) {
        let new_options = options;
        new_options.headers.previewOnly = true;

        let responseCode = 200;
        let responseMessage = "";
        debugLog("Preview Headers:" , new_options);
        await api.requests.createCsoDoc(data, new_options)
            .then(res => {
                debugLog('====Preview Response code========', res.data);
                responseCode = res.data.ResponseCode;
                responseMessage = res.data.ResponseMessage;
            }).catch(err => {
                debugError(`${err}`); 
                responseCode = err.response.data.ResponseCode;
                responseMessage = err.response.data.ResponseMessage;
            });
        
        store.dispatch("resetDefaultOptions");

        return {responseCode:responseCode,responseMessage:responseMessage}

    },

    // SORT ARRAY OF OBJECTS BASED ON STRING VALUES "Name"
    compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const NameA = a.Name.toUpperCase();
        const NameB = b.Name.toUpperCase();
      
        let comparison = 0;
        if (NameA > NameB) {
          comparison = 1;
        } else if (NameA < NameB) {
          comparison = -1;
        }
        return comparison;
    }
      
  }